export const UNAVAILABLE_EMAIL_KEY = 'UNAVAILABLE_EMAIL_KEY'
export const DATE_INITIAL_VALUE_FORMAT = 'DDMMYYYY'
export const DATE_INPUT_FORMAT = 'DD-MM-YYYY'
export const DATE_OUTPUT_FORMAT = 'YYYY-MM-DD'
